import { Colours, RoundIcon, Typography } from '@ecdlink/ui';
import React from 'react';

interface HeaderProps {
  customIcon?: string; // image URL
  icon?: string; // icon name (e.g. Heroicon)
  svgIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>; // React SVG component
  title: string;
  subTitle?: string;
  description?: string;
  tag?: string;
  backgroundColor?: Colours; // used as icon background
  iconHexBackgroundColor?: string;
  hexBackgroundColor?: string; // header background
}

export const Header = ({
  customIcon,
  icon,
  svgIcon,
  title,
  subTitle,
  description,
  tag,
  backgroundColor: iconBackgroundColor,
  iconHexBackgroundColor,
  hexBackgroundColor = '#FEF1E8',
}: HeaderProps) => {
  return (
    <div className="flex gap-2 p-4" style={{ background: hexBackgroundColor }}>
      <RoundIcon
        // Priority: svgIcon > customIcon (imageUrl) > icon (string)
        {...(svgIcon
          ? { svgIcon }
          : customIcon
          ? { imageUrl: customIcon }
          : icon
          ? { icon }
          : {})}
        iconColor="white"
        backgroundColor={iconBackgroundColor}
        hexBackgroundColor={iconHexBackgroundColor}
      />

      <div className="flex flex-col justify-center">
        <Typography
          type="h2"
          align="left"
          weight="bold"
          text={title}
          color="textDark"
        />
        {subTitle && (
          <Typography
            type="body"
            align="left"
            weight="skinny"
            text={subTitle}
            color="textMid"
          />
        )}
        {description && (
          <Typography
            type="body"
            align="left"
            weight="skinny"
            text={description}
            color="textMid"
          />
        )}
        <div className="flex">
          {tag && (
            <p className="bg-successMain text-14 w-fit rounded-2xl py-1 px-2 font-semibold text-white">
              {tag}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
